import React, { useState, useEffect } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import AgentsCard from "../AgentsCard";
import { shuffleArray } from "../../../../support/helpers";

import { useQueryParams } from "use-query-params";
import { FilterModel as sortQueryModel } from "../filterModel";
import { useSelector } from "react-redux";

const AgentsDeck = ({ agents, statesServiced, nicheItems, handleClick }) => {
    const [filteredAgents, setFilteredAgents] = useState();
    const [filterItems, setFilterItems] = useQueryParams(sortQueryModel);
    const isEntitled = useSelector((state) => state.root.isEntitled);

    useEffect(() => {
        let list = [];
        if (filterItems?.nicheItemId) {
            list = agents.filter((agent) =>
                agent.brokerAgentNicheItems.includes(filterItems?.nicheItemId)
            );
        } else if (filterItems?.stateId) {
            list = agents.filter((agent) =>
                agent.brokerAgentStates.includes(filterItems?.stateId)
            );
        }
        setFilteredAgents(list.length > 0 ? list : undefined);
    }, [filterItems, agents]);

    const buildTitle = () => {
        const using = filteredAgents || agents;
        const numberOfAgents = using.length;
        let typeOfAgent = "";
        if (filterItems?.nicheItemId) {
            const nicheItem = nicheItems.find(
                (nicheItem) => nicheItem.nicheItemId === filterItems.nicheItemId
            );
            typeOfAgent = nicheItem?.displayName || "";
        } else if (filterItems?.stateId) {
            const state = statesServiced.find(
                (state) => state.stateId === filterItems.stateId
            );
            typeOfAgent = state?.stateName || "";
        }
        return `${
            numberOfAgents > 1 ? numberOfAgents : ""
        } ${typeOfAgent} Agent${numberOfAgents > 1 ? "s" : ""}`;
    };

    const sort = (list, sortType) => {
        const newList = [...list];
        if (sortType === "firstName") {
            return newList.sort((a, b) => (a.firstName < b.firstName ? -1 : 1));
        } else if (sortType === "lastName") {
            return newList.sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
        } else {
            return shuffleArray(newList);
        }
    };

    // building agent list -- sorting if necessary
    const agentList =
        filterItems.sort && filterItems.sort !== "random"
            ? sort(filteredAgents || agents, filterItems.sort)
            : [...(filteredAgents || agents)] || agents;

    return (
        <>
            <div className="row g-0 border-top" data-test="sort-bar">
                <div className="col pt-2 d-flex flex-column flex-md flex-md-row align-items-center">
                    <div className="h5 title">{buildTitle()}</div>
                    <div className="ms-0 ms-md-auto">
                        <FormGroup className="ms-0 mb-0">
                            <Label for="sort">Sort By</Label>
                            <Input
                                className="d-inline-block w-auto ms-2"
                                style={{
                                    backgroundPosition: "right 1rem center",
                                }}
                                type="select"
                                name="sortAgents"
                                id="sort"
                                value={filterItems.sort || ""}
                                onChange={({ currentTarget }) => {
                                    setFilterItems({
                                        sort: currentTarget?.value
                                            ? currentTarget.value
                                            : undefined,
                                    });
                                }}
                            >
                                <option value="">Random</option>
                                <option value="firstName">First Name</option>
                                <option value="lastName">Last Name</option>
                            </Input>
                        </FormGroup>
                    </div>
                </div>
            </div>
            <div className="row g-0">
                {agentList.map((agent, x) => (
                    <div
                        className="col-xl-4 col-md-6 col-sm-12 p-2"
                        key={`agent-${agent.id}-${x}`}
                        data-test="agent-card-wrapper"
                    >
                        <AgentsCard
                            agent={agent}
                            statesServiced={statesServiced}
                            nicheItems={nicheItems}
                            filterItems={filterItems}
                            handleClick={handleClick}
                            stateCode={filterItems?.stateId}
                            isEntitled={isEntitled}
                        />
                    </div>
                ))}
            </div>
        </>
    );
};

export default AgentsDeck;
